import React from 'react';
import { Video } from 'lucide-react';
interface HeroProps {
  onOpenPopup: () => void;
}
export function Hero({
  onOpenPopup
}: HeroProps) {
  const imageSrc = 'https://cdn.magicpatterns.com/uploads/dovDoetuWtBoj4ZmBVgN2P/f9060944-624b-4c23-98b3-8c7f91b38366.png';
  return <section className="relative w-full min-h-[100svh] lg:min-h-[100dvh] flex items-center overflow-hidden bg-black pt-6 pb-8 lg:pt-[30px] lg:pb-12" data-id="element-51">
      <div className="w-full max-w-7xl mx-auto px-5 sm:px-10 lg:px-16 relative z-10" data-id="element-52">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-12" data-id="element-53">
          {/* Left Column - Copy */}
          <div className="w-full lg:w-1/2 flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-54">
            {/* Brand name / Signature */}
            <h1 className="font-signature text-3xl lg:text-6xl text-white opacity-90 mb-2 lg:mb-6" data-id="element-55">
              Tomás Benavidez
            </h1>

            <div className="inline-flex items-center space-x-2 bg-brand-gray/50 border border-gray-800 rounded-full px-4 py-1.5 mb-4 lg:mb-6" data-id="element-56">
              <Video className="w-4 h-4 text-brand-orange" data-id="element-57" />
              <span className="text-xs sm:text-sm font-medium text-gray-300" data-id="element-58">
                Curso Gratuito · Acceso Inmediato
              </span>
            </div>

            <h2 className="text-[1.75rem] leading-[1.15] sm:text-4xl lg:text-5xl font-bold lg:leading-tight mb-4 lg:mb-6 max-w-xl" data-id="element-59">
              Descubrí el{' '}
              <span className="underline decoration-brand-orange decoration-4 underline-offset-4" data-id="element-60">
                Sistema Paso a Paso
              </span>{' '}
              para Generar tus Primeros{' '}
              <span className="text-brand-orange text-glow" data-id="element-61">
                $2.000 USD con Ebooks
              </span>
            </h2>

            {/* Image (mobile only) - va debajo del título */}
            <div className="relative w-full max-w-[17rem] xs:max-w-sm mx-auto mb-4 lg:hidden" data-id="element-62">
              <img src={imageSrc} alt="Tomás Benavidez sosteniendo un cuadro Keep Growing de Hotmart" className="w-full h-auto max-h-[34svh] object-contain mx-auto" data-id="element-63" />
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black via-black/70 to-transparent" data-id="element-64" />
            </div>

            <p className="text-sm sm:text-base lg:text-xl text-gray-300 mb-5 lg:mb-8 leading-relaxed max-w-2xl" data-id="element-65">
              Te Revelo de Manera Totalmente Gratis el Sistema que Utilizo y que{' '}
              <strong className="text-white" data-id="element-66">Más de 200 Alumnos</strong> Aplican
              para{' '}
              <strong className="text-white" data-id="element-67">
                Crear y Escalar su Negocio de{' '}
                <span className="underline" data-id="element-68">Ebooks</span>
              </strong>
            </p>

            <button onClick={onOpenPopup} className="w-full sm:w-auto px-8 py-4 lg:py-5 bg-brand-orange hover:bg-red-600 text-white text-base lg:text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow" data-id="element-69">
              ¡QUIERO EL CURSO GRATIS AHORA!
            </button>
          </div>

          {/* Right Column - Image (desktop only) */}
          <div className="hidden lg:flex w-full lg:w-1/2 justify-center lg:justify-end" data-id="element-70">
            <div className="relative w-full max-w-sm sm:max-w-md lg:max-w-none lg:h-[84dvh]" data-id="element-71">
              <img src={imageSrc} alt="Tomás Benavidez sosteniendo un cuadro Keep Growing de Hotmart" className="w-full h-full object-contain object-bottom lg:object-right" data-id="element-72" />
              {/* Difuminado inferior: la imagen se desvanece hacia el fondo negro */}
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black via-black/70 to-transparent" data-id="element-73" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}